import { ResourceReport } from '../../types'
import apiClient from '../apiClient'
import { ENDPOINTS } from '../endpoints'

export const resourceReports = {
  list: async (siteId: string, productName: string): Promise<ResourceReport[]> => {
    const response = await apiClient.get<ResourceReport[]>(ENDPOINTS.resourceReports.list(siteId), {
      params: { productLicenseName: productName },
    })
    return response.data
  },

  downloadPdf: async (siteId: string, blobUrl: string): Promise<Blob> => {
    const response = await apiClient.get<Blob>(ENDPOINTS.resourceReports.blobProxy(siteId), {
      params: { blobUrl },
      responseType: 'blob' as const,
    })
    return response.data
  },
}
